export default {
  projectDetail: {},
  checkBdUser: [],
  groupDetail: {},
  dishesMatchDetail: {
    recordInfo: {},
  },
}
